/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit SaveAction/view.blocks to change it.
import * as fromData from 'Simple/Data'
import React from 'react'
import TysiaModalFooterAction from 'DesignSystem/TysiaModal/TysiaModalFooter/TysiaModalFooterAction/index'



/** @type {import('Simple/types.js').View} */
export default function SaveAction({
  children,
  viewPath = "/App/Account/EmbeddableCoreMessageListener/PaymentsCreateInvoice/SaveAction",
  onSubmit,
  disabled
  
}) {
let createInvoiceSubmitData = fromData.useDataSubmit({ viewPath,
context: 'create_invoice',
})
  return (<React.Fragment
>
<TysiaModalFooterAction
  viewPath={`${viewPath}/TysiaModalFooterAction`}
 type="primary"
 text="Save"
 data="create_invoice"
 onClick={createInvoiceSubmitData}
 disabled={disabled}
/>
{children}
</React.Fragment>)
}